<div class="container">
  <div class="promos-box">
    <div class="promos-header">
      <div class="image-background">
        <div class="promos-text">{{'PROMOS.TITLE' | translate}}</div>
        <div class="promo-counter">{{promoCounter}}</div>
        <div class="promo-info">
          <div>These are your available promos.</div>
          <div>They will be applied automatically when placing an order.</div>
        </div>
      </div>
    </div>
    <div class="promos-body">
      <div class="promos-desc" *ngIf="!showHowItWorks">
        <div class="code-box w-depth">
          <input class="w-depth" [placeholder]="'PROMOS.ENTER' | translate" #input
                 (input)="promoCodeClaim=$event.target.value.toUpperCase()" [(ngModel)]="promoCodeClaim">
          <button class="w-btn orange-btn btn-wave" (click)="claimPromo(promoCodeClaim)"
                  [disabled]="!promoCodeClaim">
            Claim
          </button>
        </div>
        <div class="desc-box w-depth">
          <table>
            <tr>
              <td>
                <div class="invite-text">{{'PROMOS.INVITE' | translate}}</div>
                <div class="how-btn" (click)="showHowItWorks=true">{{'PROMOS.HOWTITLE' | translate}}</div>
              </td>
            </tr>
            <tr>
              <td>
                <div>{{'PROMOS.YOURTEXT' | translate}}</div>
                <div class="code-text" *ngIf="customer?.promoCode">{{customer?.promoCode}}</div>
              </td>
            </tr>
            <tr>
              <td>
                <div class="btns" *ngIf="customer?.promoCode">
                  <a class="message-btn" [href]="sanitize(smsLink)">
                    <i class="mdi mdi-message"></i>
                  </a>
                  <a class="email-btn" [href]="sanitize(emailLink)">
                    <i class="mdi mdi-email"></i>
                  </a>
                </div>
              </td>
            </tr>
          </table>
          <app-loader-lock [displayLoader]="showLoader"></app-loader-lock>
        </div>
      </div>
      <div class="promos-how w-depth" *ngIf="showHowItWorks">
        <div class="title">
          {{'PROMOS.HOWTITLE' | translate}}
        </div>
        <div class="how-text" [innerHtml]="'PROMOS.HOWTEXT' | translate"></div>
        <div class="take-back" (click)="showHowItWorks = false">
          {{'TAKEMEBACK' | translate}}
        </div>
      </div>
    </div>
  </div>
</div>
